<template>
  <div class="is-flex is-flex-direction-column">
    <div class="columns is-multiline is-justify-content-flex-end mb-0">
      <div class="column is-full-mobile is-narrow-tablet">
        <b-input
          expanded
          :value="$route.query.keyword"
          type="text"
          placeholder="Nom..."
          icon-right-clickable
          :icon-right="$route.query.keyword ? 'close-circle' : ''"
          @icon-right-click="$router.replace({ query: { ...$route.query, keyword: undefined } })"
          @keyup.native.enter="$router.push({ query: { keyword: $event.target.value } })"
        />
      </div>

      <div class="column is-full-mobile is-narrow-tablet">
        <b-select
          expanded
          :value="$route.query.status"
          placeholder="Choisir un status"
          icon="rotate"
          @input="$router.push({ query: { ...$route.query, status: $event } })"
        >
          <option :value="null">Choisir un status</option>
          <option value="pending">En attente</option>
          <option value="completed">En cours</option>
          <option value="finished">Terminé</option>
        </b-select>
      </div>

      <div class="column is-full-mobile is-narrow-tablet">
        <b-select
          expanded
          :value="$route.query.visitorAccessType"
          placeholder="Choisir par accès"
          icon="lock"
          @input="$router.push({ query: { ...$route.query, visitorAccessType: $event } })"
        >
          <option :value="null">Choisir par accès</option>
          <option value="public">Public</option>
          <option value="private">Privé</option>
          <option value="protected">Protégé</option>
        </b-select>
      </div>

      <div class="column is-full-mobile is-narrow-tablet">
        <b-select
          expanded
          :value="$route.query.administrator"
          placeholder="Administrateur"
          icon="user"
          @input="$router.push({ query: { ...$route.query, administrator: $event } })"
        >
          <option :value="null">Choisir par administrateur</option>
          <option
            v-for="administrator in administrators"
            :key="administrator.id"
            :value="administrator.id"
          >
            {{ administrator.firstname }} {{ administrator.lastname }}
          </option>
        </b-select>
      </div>
    </div>

    <div v-show="showClearFilterButton" class="columns is-justify-content-flex-end mt-0">
      <div class="column is-full-mobile is-narrow-tablet pt-0">
        <b-button expanded class="is-small" type="is-text" @click="$router.push({ query: {} })">
          Supprimer tous les filtres
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListLivesFilter',

  props: {
    administrators: {
      type: Array,
      required: true,
    },
  },

  computed: {
    showClearFilterButton() {
      return Object.values(this.$route.query).filter((v) => v).length > 0
    },
  },
}
</script>
